module.exports = __webpack_public_path__ + "static/media/LinkedIn.fac80236.svg";